module.exports = __webpack_public_path__ + "5a631b7ab67f231ac9d9fa70e98067a4.pdf";